<template>
  <div className="animated">
    <b-card>
        <div slot="header">
            <strong>Tickets</strong>
          </div>
        <b-card-body>
          <b-collapse visible>
              <b-table
                  responsive
                  striped
                  hover
                  :items="tickets.data"
                  :fields="columnas">
                  <template  v-slot:cell(actions)="data">
                      <!--<router-link :to="`/tickets/${data.item.id}`"><i class="fa fa-edit fa-lg"></i></router-link>-->
                     <a href="#" @click="detallarTicket(data.item.id)"><i class="fa fa-edit fa-lg"></i></a>
                  </template>
              </b-table>
              <nav>
                  <b-pagination :total-rows="tickets.total" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
          </b-collapse>
        </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {ClientTable, Event} from 'vue-tables-2'

  import { mapActions,mapMutations, mapState } from "vuex";


  Vue.use(ClientTable)

  export default {
    name: 'tabla-tickets',
    components: {
      ClientTable,
      Event
    },
    data: function () {
      return {
        columnas:[
            {key: 'asunto', label: 'Asunto', sortable: true},
            {key: 'empresa', label: 'Empresa', sortable: true },
            {key: 'email', label: 'Email', sortable: true},
            {key: 'nombre', label: 'Nombre', sortable: true},
            {key: 'mensaje', label: 'Mensaje', sortable: true},
            {key: 'actions', label: 'Opciones'}
        ]
      }
    },
    created() {
      this.listarTickets()
    },
    methods: {
        ...mapActions('tickets',[
            'listarTickets',
            'detallarTicket'
        ]),
        ...mapMutations('tickets',[
            'setFiltro',
            'cambiaTicketId'
        ]),

        buscador(buscar) {
            this.setFiltro(buscar)
            this.listarTickets()
        },

    },
    computed: {
        ...mapState('tickets',[
            'tickets',
            'filtroEt'
        ])
    },
  };
</script>

<style lang="scss" scoped>
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>
